import React, { useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';

import css from './display-control-container.scss';

/**
 * Admin users require a footer on some levels of reporting to use for more specific
 * export functionality.
 */

const DisplayControlContainer = ({ children }) => {
    const isAdmin = useSelector((state) => state.isAdmin);
    const [heightBuffer, setHeightBuffer] = useState(230);

    useLayoutEffect(() => {
        if (isAdmin) setHeightBuffer(288);
    }, [isAdmin]);

    return (
        <div
            className={css['display-control-container']}
            style={{
                height: `calc(100vh - ${heightBuffer}px)`
            }}
        >
            {children}
        </div>
    );
};

DisplayControlContainer.propTypes = {
    children: PropTypes.element
};

export default styleable(css)(DisplayControlContainer);



// WEBPACK FOOTER //
// ./components/display-control-container/display-control-container.js